export const serverUrl = 'https://api.sgsextremaratio.it'